import { render } from "./delivery-date-type-update.vue?vue&type=template&id=f705ada6"
import script from "./delivery-date-type-update.vue?vue&type=script&lang=js"
export * from "./delivery-date-type-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__